/**
 * MC Timeline — the line + yellow bar act as a scrollbar/slider for the
 * horizontally-scrolling entries. Supports: drag the thumb, click the track,
 * grab-and-drag the entries, and wheel to scroll horizontally.
 */

function initTimeline( tl ) {
	const items = tl.querySelector( '.mc-timeline__items' );
	const track = tl.querySelector( '.mc-timeline__track' );
	const thumb = tl.querySelector( '.mc-timeline__thumb' );
	if ( ! items || ! track || ! thumb ) {
		return;
	}

	let draggingThumb = false;
	let draggingItems = false;
	let startX = 0;
	let startScroll = 0;
	let startLeft = 0;

	const maxScroll = () => items.scrollWidth - items.clientWidth;

	function syncThumb() {
		const ms = maxScroll();
		const trackW = track.clientWidth;
		if ( ms <= 1 ) {
			thumb.style.display = 'none';
			track.style.cursor = 'default';
			return;
		}
		thumb.style.display = '';
		track.style.cursor = 'pointer';
		// Fixed-width handle (set in CSS, ~69px) that slides along the track —
		// not a proportional scrollbar thumb.
		const thumbW = thumb.offsetWidth;
		const left = ( items.scrollLeft / ms ) * ( trackW - thumbW );
		thumb.style.left = left + 'px';
	}

	// Entries scrolled by any means → move the thumb.
	items.addEventListener( 'scroll', () => {
		if ( ! draggingThumb ) {
			syncThumb();
		}
	}, { passive: true } );

	// Vertical wheel → horizontal scroll.
	items.addEventListener( 'wheel', ( e ) => {
		if ( maxScroll() <= 1 ) {
			return;
		}
		if ( Math.abs( e.deltaY ) > Math.abs( e.deltaX ) ) {
			items.scrollLeft += e.deltaY;
			e.preventDefault();
		}
	}, { passive: false } );

	// Grab-and-drag the entries.
	items.addEventListener( 'pointerdown', ( e ) => {
		if ( maxScroll() <= 1 || e.button !== 0 ) {
			return;
		}
		draggingItems = true;
		startX = e.clientX;
		startScroll = items.scrollLeft;
		items.classList.add( 'is-dragging' );
	} );
	items.addEventListener( 'pointermove', ( e ) => {
		if ( ! draggingItems ) {
			return;
		}
		const dx = e.clientX - startX;
		if ( Math.abs( dx ) > 3 ) {
			items.setPointerCapture( e.pointerId );
		}
		items.scrollLeft = startScroll - dx;
	} );
	const endItems = ( e ) => {
		if ( ! draggingItems ) {
			return;
		}
		draggingItems = false;
		items.classList.remove( 'is-dragging' );
		try { items.releasePointerCapture( e.pointerId ); } catch ( err ) {}
	};
	items.addEventListener( 'pointerup', endItems );
	items.addEventListener( 'pointercancel', endItems );

	// Drag the yellow thumb.
	thumb.addEventListener( 'pointerdown', ( e ) => {
		e.stopPropagation();
		e.preventDefault();
		draggingThumb = true;
		startX = e.clientX;
		startLeft = parseFloat( thumb.style.left ) || 0;
		tl.classList.add( 'is-dragging-thumb' );
		thumb.setPointerCapture( e.pointerId );
	} );
	thumb.addEventListener( 'pointermove', ( e ) => {
		if ( ! draggingThumb ) {
			return;
		}
		const trackW = track.clientWidth;
		const thumbW = thumb.offsetWidth;
		let left = startLeft + ( e.clientX - startX );
		left = Math.max( 0, Math.min( left, trackW - thumbW ) );
		thumb.style.left = left + 'px';
		items.scrollLeft = ( left / ( trackW - thumbW ) ) * maxScroll();
	} );
	const endThumb = ( e ) => {
		if ( ! draggingThumb ) {
			return;
		}
		draggingThumb = false;
		tl.classList.remove( 'is-dragging-thumb' );
		try { thumb.releasePointerCapture( e.pointerId ); } catch ( err ) {}
		syncThumb();
	};
	thumb.addEventListener( 'pointerup', endThumb );
	thumb.addEventListener( 'pointercancel', endThumb );

	// Click the track to jump.
	track.addEventListener( 'pointerdown', ( e ) => {
		if ( e.target === thumb || maxScroll() <= 1 ) {
			return;
		}
		const rect = track.getBoundingClientRect();
		const thumbW = thumb.offsetWidth;
		let left = e.clientX - rect.left - ( thumbW / 2 );
		left = Math.max( 0, Math.min( left, rect.width - thumbW ) );
		items.scrollLeft = ( left / ( rect.width - thumbW ) ) * maxScroll();
	} );

	window.addEventListener( 'resize', syncThumb );
	syncThumb();
	setTimeout( syncThumb, 300 );
}

document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll( '.mc-timeline' ).forEach( initTimeline );
} );
